<template>
  <v-sheet color="transparent" class="mt-6 mt-sm-8 mt-lg-10">
    <LightGallery
      :images="images"
      :index="index"
      :disable-scroll="true"
      @close="index = null"
    />

    <TitleWidget small class="primary--text justify-center text-center">
      Galeria de Fotos
    </TitleWidget>

    <div class="mt-6 mt-md-8 grid-list-images">
      <div
        class="grid-list-images-item"
        v-for="(img, i) in images"
        :key="i"
        @click="index = i"
      >
        <img :src="img + '?resize=1&w=600'" class="d-block" />
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { LightGallery } from "vue-light-gallery";
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  props: {
    images: {
      type: Array,
    },
  },
  data: () => ({
    index: null,
  }),
  components: {
    LightGallery,
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list-images {
  display: grid;
  gap: 30px;
  grid-template-columns: 1fr 1fr 1fr;
  @media screen and (max-width: 960px) {
    gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 600px) {
    gap: 5px;
  }
  .grid-list-images-item {
    img {
      aspect-ratio: 360 / 210;
      cursor: pointer;
      object-fit: cover;
      -o-object-fit: cover;
      width: 100%;
    }
  }
}
</style>
